// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueSimpleAlert from "vue-simple-alert"
import DatepickerInput from "./components/b122/editFields/DatepickerInput";

import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/config.css'
import './assets/css/B122Table.css'
import './assets/css/main.css'
import VCalendar from 'v-calendar'
import VueTablerIcons from 'vue-tabler-icons'
import i18n from './i18n'
import VueApexCharts from 'vue-apexcharts'
import {MonthPicker} from 'vue-month-picker'
import {MonthPickerInput} from 'vue-month-picker'

import * as Sentry from '@sentry/vue'
import {Integrations} from '@sentry/tracing'

import setupInterceptors from './services/setupInterceptors'
import * as VueGoogleMaps from 'vue2-google-maps'

import fr from './locales/fr.json'
import frLni from './locales/fr.lni.json'

Vue.config.productionTip = false

// Make BootstrapVue available throughout project
Vue.component('DatepickerInput', DatepickerInput)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueApexCharts)
Vue.use(MonthPicker)
Vue.use(MonthPickerInput)
import TokenService from "./services/tokenService";
import {applyBrandTheme} from "./utils/theme";

Vue.use(VueSimpleAlert, {reverseButtons: true, cancelButtonText: i18n.t('Cancel')})

Vue.component('apexchart', VueApexCharts)

// Lib utlisée pour les icones
// Version 1.* (compatible avec Vue 2)
// Icones : https://tabler-icons.io/
// Documentation lib : https://github.com/alex-oleshkevich/vue-tabler-icons
Vue.use(VueTablerIcons)

setupInterceptors(store, router)

Vue.use(VCalendar, {
  componentPrefix: 'vc' // Use <vc-calendar /> instead of <v-calendar />
})

Vue.directive('disable-scroll', {
  bind: function (el) {
    el.addEventListener('wheel', function (e) {
      e.target.blur();
    })
  }
})
Vue.directive('unsaveDetector', {
  bind(el, binding, vnode) {
    const changeHandler = () => {
      vnode.context.$store.commit('setUnsavedChanges', true);
    };

    const forms = el.querySelectorAll('input, textarea, select,.form-control,[type="date"]');
    forms.forEach(formElement => {
      formElement.addEventListener('change', changeHandler);
      if (formElement.className && formElement.className.includes('b-form-datepicker')) {
        formElement.addEventListener('input', changeHandler);
      }
    });

    const submitHandler = (event) => {
      vnode.context.$store.commit('setUnsavedChanges', false);
    };

    el.addEventListener('click', submitHandler);

    el.__vueUnsaveDetectorChangeHandler__ = changeHandler;
    el.__vueUnsaveDetectorSubmitHandler__ = submitHandler;
  },

  unbind(el) {
    const forms = el.querySelectorAll('input, textarea, select');
    if (el.__vueUnsaveDetectorChangeHandler__) {
      forms.forEach(formElement => {
        formElement.removeEventListener('change', el.__vueUnsaveDetectorChangeHandler__);
        if (formElement.className && formElement.className.includes('b-form-datepicker')) {
          formElement.removeEventListener('input', el.__vueUnsaveDetectorChangeHandler__);
        }
      });
    }

    if (el.__vueUnsaveDetectorSubmitHandler__) {
      el.removeEventListener('submit', el.__vueUnsaveDetectorSubmitHandler__);
    }
    delete el.__vueUnsaveDetectorChangeHandler__;
    delete el.__vueUnsaveDetectorSubmitHandler__;
  },
});


Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBBP9B-iaSsNPOCXiFa0Afi1kGCARrSPF0', libraries: 'places',
  },
})

Vue.filter('formatEuro', function (value) {
  if (!value && value !== 0) return '-';
  const formatter = new Intl.NumberFormat('fr-FR', {
    style: 'currency', currency: 'EUR',
  });
  return formatter.format(value);
});

// Sentry
if (['preproduction', 'production'].includes(process.env.NODE_ENV)) {
  Sentry.init({
    Vue,
    tunnel: `${process.env.SERVER_URL}/sentry/tunnel`,
    dsn: 'https://abd55b8df35747ad83c7e35cb28b0793@o493491.ingest.sentry.io/4505012612300800',
    environment: process.env.NODE_ENV,
    tracesSampleRate: 1,
    attachProps: true,
    beforeBreadcrumb(breadcrumb, hint) {
      if ((breadcrumb.category === 'console' || breadcrumb.category === "sentry.event") && breadcrumb.message && (breadcrumb.message.includes('[Vue warn]') || breadcrumb.message.includes('[vue-i18n]' || breadcrumb.message.includes('NavigationDuplicated')))) {
        return null;
      }
      if (breadcrumb.category === 'xhr' && breadcrumb.data && breadcrumb.data && (breadcrumb.data.status_code === 500 || breadcrumb.data.status_code === 404)) {
        const dataString = JSON.stringify(breadcrumb.data, null, 2);
        Sentry.captureMessage(`XHR request failed with status ${breadcrumb.data.status_code} => ${dataString} at ${new Date().toISOString()}`, 'error');
      }
      return breadcrumb;
    },
    beforeSend: async event => {
      if (event && event.exception && event.exception.values[0].type === "NavigationDuplicated") {
        return
      }
      if (event.message.startsWith(`XHR request failed with status`) || event.message.startsWith("feedback")) {
        localStorage.setItem('lastEventId', event.event_id)
      } else {
        localStorage.setItem('lastEventId', null)
      }
      return event;
    },
    transportOptions: {
      fetchParameters: {
        headers: {
          'Authorization': 'Bearer ' + TokenService.getLocalAccessToken(), 'Content-Type': 'application/json'
        }, referrerPolicy: 'strict-origin-when-cross-origin'
      }
    }
  })
}


export const bus = new Vue();

Vue.prototype.$globalConfirm = function (message) {
  return new Promise((resolve, reject) => {
    bus.$confirm(message)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(false);
      });
  });
};


/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  components: { App },
  template: '<App/>',
  mounted() {
    const brand = this.$store.getters['brand/brand']

    applyBrandTheme(brand)

    document.title = brand.title

    const favicon = document.getElementById('favicon')
    if (favicon) {
      favicon.href = brand.favicon
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js